import config from './config.xml';
import tasks from './tasks.json';
import annotation from './annotations/0.json';

export const Table = { config, tasks, annotation };
